export const useCheckForUser = (pId) => {
  const trimmedId = pId?.trim?.();
  const BETA_TESTING_ALLOWED_USERS = [
    "47001043002",
    "01019087670",
    "19001105386",
    "01024067385",
    "42001034769",
    "31001020607",
    "01003015794",
    "35001117728",
    "01007013234",
    "62001045404",
    "1019070299",
    "19001010565",
    "39001019268",
  ];
  return BETA_TESTING_ALLOWED_USERS.includes(trimmedId);
};
